<template>
  <PrivacySection title="7. Comunicazione e Diffusione dei Dati">
    <p>
      I dati personali non sono oggetto di diffusione, vendita o comunicazione a terzi, 
      salvo nei seguenti casi:
    </p>
    <ul>
      <li><strong>Autorità Competenti:</strong> quando richiesto dalla legge o da 
          un'autorità giudiziaria o amministrativa</li>
      <li><strong>Fornitori di Servizi:</strong> possiamo condividere dati con fornitori 
          di servizi che ci assistono nell'erogazione dei Servizi (ad esempio, servizi 
          di hosting, servizi email), i quali sono obbligati a trattare i dati secondo 
          le nostre istruzioni e in conformità con questa Privacy Policy</li>
      <li><strong>Sito Governativo della Lotteria:</strong> quando l'utente utilizza 
          l'applicazione per accedere al sito governativo, i dati necessari (codice fiscale) 
          vengono trasmessi direttamente al sito governativo, sul quale non abbiamo 
          alcun controllo</li>
    </ul>
    <p>
      Non trasferiamo dati personali al di fuori dell'Unione Europea, salvo che il 
      trasferimento sia necessario per l'erogazione dei Servizi e sia effettuato in 
      conformità con le disposizioni del GDPR.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'

export default {
  name: 'DataSharingSection',
  components: {
    PrivacySection
  }
}
</script>

